import React from 'react'

const RuleIcon = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM4.60974 10.7145C5.2194 7.18484 8.29616 4.5 12 4.5C15.7038 4.5 18.7806 7.18484 19.3903 10.7145C16.6977 9.66286 14.3575 9.12499 12 9.12499C9.64254 9.12498 7.30225 9.66284 4.60974 10.7145ZM4.5018 11.8341C4.5006 11.8893 4.5 11.9446 4.5 12C4.5 15.9741 7.59098 19.2263 11.5 19.4836V15.6193C10.2543 13.1871 8.68432 12.1796 7.29985 11.2911C7.14106 11.1892 6.98467 11.0888 6.83153 10.9881C6.08725 11.2218 5.31432 11.5036 4.5018 11.8341ZM19.5 12C19.5 15.9741 16.409 19.2263 12.5 19.4836V15.6193C13.7457 13.1871 15.3157 12.1796 16.7001 11.2911C16.859 11.1892 17.0153 11.0889 17.1685 10.9881C17.9127 11.2219 18.6857 11.5036 19.4982 11.8341C19.4994 11.8893 19.5 11.9446 19.5 12Z"
    />
  </svg>
)

export default RuleIcon
